import React from 'react';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./Inspector'));

function IFrame({ link }) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div className={clsx(style.block, isEditing && style.editing)}>
            <iframe title="Contenu embarqué" src={link}></iframe>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: IFrame,
    smartProps: {
        link: smartProps.string.withDefault('https://www.fertrecyclage.com/pieces-detachees.html'),
    },
    setup: {
        title: 'IFrame',
    },
});
